document.addEventListener("DOMContentLoaded", () => {
  // -----------------------
  // CONFIG: slide => areas
  // -----------------------
const slideMaps = {
  "slideshow__slide-slide_barY6J": [
    {
      coords: "89,377,87,445,26,472,28,550,107,558,107,738,230,738,229,548,250,546,251,739,348,739,346,474,372,467,402,462,417,440,417,390,382,382,345,379,275,380,275,369,320,363,317,340,304,343,303,330,230,332,230,385,203,393,176,391,177,375",
      href: "https://www.bathwise.uk.com/products/bellona-single-lever-basin-mixer-including-waste",
      title: "[PFDITS1238] Bellona Single Lever Basin Mixer Including Waste",
      productId: "bellona-single-lever-basin-mixer-including-waste"
    },
    {
      coords: "740,141,740,228,758,228,758,265,743,265,743,297,718,297,681,297,681,173,706,172,706,212,714,212,713,141",
      href: "https://www.bathwise.uk.com/products/marne-freestanding-single-lever-bathshower-mixer-including-shower-kit-chrome",
      title: "[PFDITB1102] Marne Freestanding Single Lever Bath/Shower Mixer Including Shower Kit Chrome",
      productId: "marne-freestanding-single-lever-bathshower-mixer-including-shower-kit-chrome"
    },
    {
      coords: "983,275,970,310,949,366,933,403,914,437,894,471,878,487,824,493,737,493,682,492,623,492,579,489,557,479,526,427,497,369,476,318,467,279,476,268,501,267,542,273,597,281,650,286,739,287,806,284,885,276,972,265",
      href: "https://www.bathwise.uk.com/products/belmont-1700x780mm-freestanding-bath-including-waste-kit",
      title: "[PFDIBF0068] Belmont 1700x780mm Freestanding Bath Including Waste Kit",
      productId: "belmont-1700x780mm-freestanding-bath-including-waste-kit"
    },
    {
      coords: "1423,372,1422,557,1433,631,1446,703,1478,738,1613,738,1623,685,1632,627,1639,552,1599,523,1599,373",
      href: "https://www.bathwise.uk.com/products/cilantro-close-coupled-toilet-with-soft-close-seat",
      title: "[PFDIPTP0162] Cilantro Close Coupled Toilet With Soft Close Seat",
      productId: "cilantro-close-coupled-toilet-with-soft-close-seat"
    }
  ],
  "slideshow__slide-slide_6fkxhC": [
    {
      coords: "931,39,930,541,997,554,1110,544,1107,30,989,26",
      href: "https://www.bathwise.uk.com/products/lambra-wall-mounted-storage-unit",
      title: "[PFDIFT1806] Lambra Wall Mounted Storage Unit",
      productId: "lambra-wall-mounted-storage-unit"
    },
    {
      coords: "79,493,160,739,846,739,912,482,898,465,878,457,848,454,814,457,692,485,599,506,491,522,380,525,248,514,92,483",
      href: "https://www.bathwise.uk.com/products/belmont-1700x780mm-freestanding-bath-including-waste-kit",
      title: "[PFDIBF0068] Belmont 1700x780mm Freestanding Bath Including Waste Kit",
      productId: "belmont-1700x780mm-freestanding-bath-including-waste-kit"
    },
    {
      coords: "1687,398,1685,704,1525,724,1295,676,1292,387,1391,385",
      href: "https://www.bathwise.uk.com/products/lambra-wall-mounted-twin-drawer-unit-with-basin",
      title: "[PFDIFTP1810] Lambra Wall Mounted Twin Drawer Unit With Basin",
      productId: "lambra-wall-mounted-twin-drawer-unit-with-basin"
    },
    {
      coords: "1555,336,1554,411,1507,410,1507,378,1488,376,1475,360,1481,345,1497,334",
      href: "https://www.bathwise.uk.com/products/berio-basin-mixer-including-waste",
      title: "[PFDITS1328] Berio Basin Mixer Including Waste",
      productId: "berio-basin-mixer-including-waste"
    },
    {
      coords: "375,376,375,544,476,545,476,505,494,505,493,458,510,452,509,420,441,407,419,407,419,376",
      href: "https://www.bathwise.uk.com/products/berio-freestanding-bath-shower-mixer",
      title: "[PFDITB2280] Berio Freestanding Bath Shower Mixer",
      productId: "berio-freestanding-bath-shower-mixer"
    }
  ],
  "slideshow__slide-slide_Bg6diq": [
    {
      coords: "320,2,319,684,263,685,263,735,406,735,406,689,374,685,425,668,504,664,510,624,486,619,491,605,523,581,509,412,491,272,478,208,478,-2,404,-2",
      href: "https://www.bathwise.uk.com/products/grado-straight-ladder-towel-warmer",
      title: "[PFDIRA0254] Grado Straight Ladder Towel Warmer",
      productId: "grado-straight-ladder-towel-warmer"
    },
    {
      coords: "613,-2,611,309,629,327,912,327,941,309,939,-2,767,-2",
      href: "#",
      title: "Cosmos Mirror",
      productId: "cosmos-mirror"
    },
    {
      coords: "587,426,980,426,981,492,968,513,967,714,554,715,554,505,544,490,544,443",
      href: "https://www.bathwise.uk.com/products/cosmos-wall-mounted-single-drawer-basin-and-unit",
      title: "[PFDIFTP2784] Cosmos Wall Mounted Single Drawer Basin And Unit",
      productId: "cosmos-wall-mounted-single-drawer-basin-and-unit"
    },
    {
      coords: "1177,23,1174,684,1198,713,1414,713,1412,-2,1197,-2",
      href: "https://www.bathwise.uk.com/products/cosmos-wall-mounted-storage-unit",
      title: "[PFDIFT2838] Cosmos Wall Mounted Storage Unit",
      productId: "cosmos-wall-mounted-storage-unit"
    },
    {
      coords: "751,335,751,441,803,442,803,335",
      href: "#",
      title: "Cosmos Tap",
      productId: "cosmos-tap"
    }
  ]
};


  const ORIGINAL_W = 1820;
  const ORIGINAL_H = 740;

  const SHADOW_RADIUS_BASE = 2;
  const SHADOW_BLUR_BASE = 5;
  const SHADOW_COLOR = "rgb(15, 15, 15)";

  function parseCoords(coordsStr) {
    return coordsStr.split(",").map(s => parseFloat(s.trim()));
  }

  // -----------------------
  // Shopify product modal
  // -----------------------
  function createProductModal() {
    const modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = "50%";
    modal.style.left = "50%";
    modal.style.transform = "translate(-50%, -50%)";
    modal.style.background = "#fff";
    modal.style.borderRadius = "10px";
    modal.style.boxShadow = "0 5px 30px rgba(0,0,0,0.5)";
    modal.style.zIndex = "10001";
    modal.style.maxWidth = "500px";
    modal.style.maxHeight = "90%";
    modal.style.overflowY = "auto";
    modal.style.padding = "20px";
    modal.style.display = "none";
    modal.id = "product-modal";

    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.background = "rgba(0,0,0,0.5)";
    overlay.style.zIndex = "10000";
    overlay.style.display = "none";
    overlay.id = "product-modal-overlay";
    overlay.addEventListener("click", () => {
      modal.style.display = "none";
      overlay.style.display = "none";
    });

    const closeBtn = document.createElement("button");
    closeBtn.textContent = "✕";
    closeBtn.style.position = "absolute";
    closeBtn.style.top = "10px";
    closeBtn.style.right = "10px";
    closeBtn.style.background = "transparent";
    closeBtn.style.border = "none";
    closeBtn.style.fontSize = "20px";
    closeBtn.style.cursor = "pointer";
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
      overlay.style.display = "none";
    });

    modal.appendChild(closeBtn);
    document.body.appendChild(modal);
    document.body.appendChild(overlay);
    return { modal, overlay };
  }

  const { modal: productModal, overlay: modalOverlay } = createProductModal();

  async function fetchProductData(productId) {
    try {
      const res = await fetch(`/products/${productId}.js`);
      if (!res.ok) throw new Error("Product not found");
      return await res.json();
    } catch (err) {
      console.error(err);
      return null;
    }
  }
async function showProduct(productId) {
  const product = await fetchProductData(productId);
  if (!product) {
    productModal.innerHTML = '<p>Product not found</p>';
  } else {
    let html = `
    <h3 class="h3 featured-product__heading">${product.title}</h3>

<div class="poly-product-wrapper">

  <!-- Featured image + Thumbnails wrapper -->
  <div class="poly-featured-img-thumbs">
    <!-- Featured image -->
    <div id="poly-featured-img-box" class="poly-featured-img">
      ${product.images && product.images.length ? `
        <img id="poly-featured-img"
          src="${product.images[0]}"
          style="width:100%; max-height:450px; object-fit:cover; border-radius:8px;">
      ` : ''}
    </div>

    <!-- Thumbnails right vertical -->
    <div class="poly-thumbnails">
      ${
        product.images && product.images.length > 1
          ? product.images.slice(1).map(img => `
              <img class="thumb-image"
                data-full="${img}"
                src="${img}"
                style="width:100px; height:100px; object-fit:cover; border-radius:6px; cursor:pointer;">
            `).join('')
          : ''
      }
    </div>
  </div>

  <!-- Description + CTA -->
  <div class="poly-product-details">
    <p class="poly-product-desc">
      ${(product.description || '').substring(0, 180)}${(product.description || '').length > 100 ? '…' : ''}
    </p>
    <a href="${product.url || `/products/${product.handle}`}" 
       target="_blank"
       class="cards-grid__button button button--primary button--arrow">
      <span class="cards-grid__button-label">Check it out</span>
      <span class="cards-grid__button-arrow">
        <svg class="icon icon-button-arrow" viewBox="0 0 24 23" fill="none" 
             xmlns="http://www.w3.org/2000/svg">
          <path d="M14 11.5713L10 15.3809L10 7.76181L14 11.5713Z" fill="currentColor"></path>
        </svg>
      </span>
    </a>
  </div>
</div>


    `;


    productModal.innerHTML = '';

    // CLOSE BUTTON
    const closeBtn = document.createElement("button");
    closeBtn.textContent = "✕";
    closeBtn.style.position = "absolute";
    closeBtn.style.top = "10px";
    closeBtn.style.right = "10px";
    closeBtn.style.background = "transparent";
    closeBtn.style.border = "none";
    closeBtn.style.fontSize = "26px";
    closeBtn.style.cursor = "pointer";
    closeBtn.addEventListener("click", closeModal);
    productModal.appendChild(closeBtn);

    const contentWrapper = document.createElement("div");
    contentWrapper.innerHTML = html;
    productModal.appendChild(contentWrapper);

    /*** THUMBNAIL CLICK → CHANGE FEATURED IMAGE ***/
    productModal.querySelectorAll(".thumb-image").forEach(thumb => {
      thumb.addEventListener("click", () => {
        const featured = document.getElementById("poly-featured-img");
        featured.src = thumb.dataset.full;
      });
    });
  }

  openModal();
}

/*** OPEN / CLOSE ***/
function openModal() {
  productModal.style.display = "block";
  modalOverlay.style.display = "block";
}

function closeModal() {
  productModal.style.display = "none";
  modalOverlay.style.display = "none";
}

/*** CLICK OUTSIDE TO CLOSE ***/
modalOverlay.addEventListener("click", closeModal);

  // -----------------------
  // Polygon mapping logic
  // -----------------------
  function initForSlideElement(slideEl) {
    if (!slideEl || !(slideEl instanceof Element)) return;

    const matchedKey = Object.keys(slideMaps).find(key => slideEl.className && slideEl.className.includes(key));
    if (!matchedKey) return;
    if (slideEl.dataset.polyInit === "true") return;

    const img = slideEl.querySelector("img.slideshow__image") || slideEl.querySelector("img");
    if (!img) return;

    const container = img.parentElement || slideEl;
    if (getComputedStyle(container).position === "static") container.style.position = "relative";
    if (container.querySelector('svg[data-mapped="true"]')) {
      slideEl.dataset.polyInit = "true";
      return;
    }

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("data-mapped", "true");
    svg.style.position = "absolute";
    svg.style.left = "-2.5%";
    svg.style.top = "0";
    svg.style.width = "100%";
    svg.style.height = "100%";
    svg.style.pointerEvents = "auto";
    svg.style.zIndex = "9998";
    container.appendChild(svg);

    const label = document.createElement("div");
    label.style.position = "fixed";
    label.style.background = "rgba(0,0,0,0.78)";
    label.style.color = "#fff";
    label.style.padding = "6px 10px";
    label.style.borderRadius = "6px";
    label.style.fontSize = "13px";
    label.style.pointerEvents = "none";
    label.style.opacity = "0";
    label.style.transition = "opacity .15s";
    label.style.zIndex = "10000";
    document.body.appendChild(label);

    const areas = slideMaps[matchedKey] || [];

    const overlay = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    overlay.setAttribute("x", 0);
    overlay.setAttribute("y", 0);
    overlay.setAttribute("width", "100%");
    overlay.setAttribute("height", "100%");
    overlay.setAttribute("fill", "rgba(0,0,0,0.35)");
    overlay.style.pointerEvents = "none";
    overlay.style.transition = "opacity 0.2s";
    overlay.style.opacity = "0";
    svg.appendChild(overlay);

    const mask = document.createElementNS("http://www.w3.org/2000/svg", "mask");
    mask.setAttribute("id", "mask-" + Math.random().toString(36).substr(2, 5));
    svg.appendChild(mask);

    const whiteRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    whiteRect.setAttribute("x", 0);
    whiteRect.setAttribute("y", 0);
    whiteRect.setAttribute("width", "100%");
    whiteRect.setAttribute("height", "100%");
    whiteRect.setAttribute("fill", "white");
    mask.appendChild(whiteRect);

    const maskPoly = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
    mask.appendChild(maskPoly);
    overlay.setAttribute("mask", `url(#${mask.id})`);

    const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
    svg.appendChild(defs);

    const filterId = "inner-shadow-" + Math.random().toString(36).substr(2, 5);
    const filter = document.createElementNS("http://www.w3.org/2000/svg", "filter");
    filter.setAttribute("id", filterId);
    filter.setAttribute("x", "-50%");
    filter.setAttribute("y", "-50%");
    filter.setAttribute("width", "200%");
    filter.setAttribute("height", "200%");
    defs.appendChild(filter);

    const feMorph = document.createElementNS("http://www.w3.org/2000/svg", "feMorphology");
    feMorph.setAttribute("in", "SourceAlpha");
    feMorph.setAttribute("operator", "erode");
    feMorph.setAttribute("radius", SHADOW_RADIUS_BASE);
    filter.appendChild(feMorph);

    const feBlur = document.createElementNS("http://www.w3.org/2000/svg", "feGaussianBlur");
    feBlur.setAttribute("stdDeviation", SHADOW_BLUR_BASE);
    filter.appendChild(feBlur);

    const feFlood = document.createElementNS("http://www.w3.org/2000/svg", "feFlood");
    feFlood.setAttribute("flood-color", SHADOW_COLOR);
    filter.appendChild(feFlood);

    const feComposite = document.createElementNS("http://www.w3.org/2000/svg", "feComposite");
    feComposite.setAttribute("in2", "SourceAlpha");
    feComposite.setAttribute("operator", "in");
    filter.appendChild(feComposite);

    const polygons = areas.map(area => {
      const poly = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      poly.setAttribute("fill", "rgba(0,0,0,0)");
      poly.setAttribute("stroke", "rgba(0,0,0,0.0)");
      poly.style.cursor = "pointer";
      poly.style.pointerEvents = "all";
      svg.appendChild(poly);

      poly.addEventListener("mousemove", (ev) => {
        label.textContent = area.title || "";
        label.style.left = ev.clientX + 12 + "px";
        label.style.top = ev.clientY + 12 + "px";
        label.style.opacity = "1";
      });
      poly.addEventListener("mouseleave", () => label.style.opacity = "0");

      poly.addEventListener("click", () => {
        if (area.productId) showProduct(area.productId);
      });

      poly.addEventListener("mouseenter", () => {
        const rect = img.getBoundingClientRect();
        const pw = rect.width * 1.05;
        const ph = rect.height;
        const nums = parseCoords(area.coords);
        const scaled = [];
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        for (let j = 0; j < nums.length; j += 2) {
          const x = (nums[j] / ORIGINAL_W) * pw;
          const y = (nums[j + 1] / ORIGINAL_H) * ph;
          scaled.push(`${x},${y}`);
          minX = Math.min(minX, x); maxX = Math.max(maxX, x);
          minY = Math.min(minY, y); maxY = Math.max(maxY, y);
        }
        maskPoly.setAttribute("points", scaled.join(" "));
        maskPoly.setAttribute("fill", "white");

        const polyWidth = maxX - minX;
        const polyHeight = maxY - minY;
        const dynamicRadius = Math.max(2, Math.min(polyWidth, polyHeight) * 0.01);
        const dynamicBlur = dynamicRadius * 2;
        feMorph.setAttribute("radius", dynamicRadius);
        feBlur.setAttribute("stdDeviation", dynamicBlur);

        maskPoly.setAttribute("filter", `url(#${filterId})`);
        overlay.style.opacity = "1";
      });

      poly.addEventListener("mouseleave", () => {
        overlay.style.opacity = "0";
        maskPoly.removeAttribute("filter");
      });

      return { poly, coords: area.coords };
    });

    function updatePolygons() {
      const rect = img.getBoundingClientRect();
      const iw = rect.width;
      const ih = rect.height;
      if (!(iw > 5 && ih > 5)) return;
      const sx = iw / ORIGINAL_W;
      const sy = ih / ORIGINAL_H;

      polygons.forEach(({ poly, coords }) => {
        const nums = parseCoords(coords);
        if (!nums || nums.length < 6) return;
        const scaled = [];
        for (let i = 0; i < nums.length; i += 2) {
          const x = nums[i] * sx * 1.05;
          const y = (nums[i + 1] || 0) * sy * 1.05;
          scaled.push(x + "," + y);
        }
        poly.setAttribute("points", scaled.join(" "));
      });
    }

    function ensureReadyAndUpdate() {
      if (img.complete && img.naturalWidth && img.clientWidth > 5) {
        updatePolygons();
      } else img.addEventListener("load", updatePolygons, { once: true });
    }

    let ro;
    try { ro = new ResizeObserver(updatePolygons); ro.observe(img); }
    catch (e) { window.addEventListener("resize", updatePolygons); }
    window.addEventListener("resize", updatePolygons);
    ensureReadyAndUpdate();

    slideEl.dataset.polyInit = "true";

    const mo = new MutationObserver(() => {
      if (!document.body.contains(slideEl)) {
        try { svg.remove(); } catch { }
        try { label.remove(); } catch { }
        try { ro && ro.disconnect(); } catch { }
        try { mo.disconnect(); } catch { }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function initExistingSlides() {
    const allSlides = Array.from(document.querySelectorAll("div.slideshow__slide"));
    if (!allSlides.length) console.info("No slide elements found at DOMContentLoaded. Will watch for slides being added...");
    allSlides.forEach(slideEl => initForSlideElement(slideEl));
  }

  initExistingSlides();

  const pageObserver = new MutationObserver(muts => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches("div.slideshow__slide")) initForSlideElement(node);
          else {
            const slides = node.querySelectorAll && node.querySelectorAll("div.slideshow__slide");
            if (slides && slides.length) slides.forEach(s => initForSlideElement(s));
          }
        });
      }
    }
  });

  pageObserver.observe(document.body, { childList: true, subtree: true });

  console.info("Slide polygon mapping initializer active with Shopify product modal, gallery & 'Check it out' button.");
});
